import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Combine twMerge with cn for a cleaner syntax
export const cn = (...inputs:ClassValue[]) => twMerge(clsx(inputs));
